import Views from "@qpr/client-api-base/app/Views";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import WFSteps from "@qpr/client-api-base/pages/kpiworkflowsteps";
import React from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import LandingPage from "./pages/landingpage/index";

import useRanges from "@qpr/client-api-base/hooks/useRangeContext";

import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import usePeriodLevels from "backend/hooks/model/usePeriodLevels";
import CascadePage from "pages/cascade";
import CompletedTasks from "pages/completedtasks";
import ConfigurableReports from "pages/configurablereports";
import Division from "pages/division";
import ElementTest from "pages/elementtest";
import ExecutiveDashboard from "pages/executivedashboard";
import InitiativeDetails from "pages/initiativedetails";
import Initiatives from "pages/initiatives";
import KPIDetails from "pages/kpidetails";
import KPIs from "pages/kpis";
import KPisAndInitiaivesView from "pages/kpisandinitiatives";
import MyTasks from "pages/mytasks";
import Overview from "pages/overview";
import Perspective from "pages/perspective";
import Playground from "pages/playground/Playground";
import ReportTemplates from "pages/reporttemplates";
import StrategyMap from "pages/strategymap";
import WorkflowAdmin from "pages/workflowadmin";
import WorkflowConfigs from "pages/workflowconfigs";
import WorkflowInput from "pages/workflowinput";

const SamplePage = () => {
  const ctx = useAppContext();
  return (
    <div>
      <WFSteps />
    </div>
  );
};

const SubViews = () => {
  const tenant = useCurrentTenant();
  const ctx = useAppContext();
  const periods = usePeriodLevels();
  return (
    <Views>
      <div style={{ marginTop: "70px" }}>
        <Route
          path={`/${tenant.symbol}/${ctx.model}/playground`}
          component={Playground}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/elementtest`}
          component={ElementTest}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/corporate`}
          component={StrategyMap}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/cascade`}
          component={CascadePage}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/mytasks`}
          component={MyTasks}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/workflowconfigs`}
          component={WorkflowConfigs}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/workflowinput`}
          component={WorkflowInput}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/completedtasks`}
          component={CompletedTasks}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/executivedashboard`}
          component={ExecutiveDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/strategymap/:id?/:meaId?/`}
          component={StrategyMap}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/division/:id?/:meaId?/`}
          component={Division}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/overview/:id?/:meaId?/`}
          component={Overview}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/kpis/:id?/:meaId?/`}
          component={KPIs}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/initiatives/:id?/:meaId?/`}
          component={Initiatives}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/objective/:id?/:meaId?/`}
          component={KPisAndInitiaivesView}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/perspective/:id?/:meaId?/`}
          component={Perspective}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/kpidetails/:id?/:meaId?/`}
          component={KPIDetails}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/initiativedetails/:id?/:meaId?/`}
          component={InitiativeDetails}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/reporttemplates`}
          component={ReportTemplates}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/configurablereports`}
          component={ConfigurableReports}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.model}/workflowadmin`}
          component={WorkflowAdmin}
        />
      </div>
    </Views>
  );
};

const Routes = () => {
  const { path } = useRouteMatch();
  const tenant = useCurrentTenant();
  const ctx = useAppContext();
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();
  // initialize
  React.useEffect(() => {
    if (tenant.symbol && tenant.symbol !== ctx.tenant) {
      ctx.sendValue("tenant", tenant.symbol);
    }
    if (params.model !== ctx.model) {
      if (params.model) {
        ctx.sendValue("model", params.model);
      } else {
        ctx.sendValue("model", "v0.5");
      }
    }
    if (!ctx.period) {
      const currentDate = new Date();
      ctx.sendValue("period", currentDate.getFullYear().toString());
    }
  }, [params.model, ctx.period, ctx.model, tenant.symbol]);

  useRanges();
  return (
    <Switch>
      <Route path={`/${tenant.symbol}/`} exact component={LandingPage} />
      <Route path={`/${tenant.symbol}/:model/`} exact component={LandingPage} />
      <Route path={`${path}/`} component={LandingPage} exact />
      <Route
        path={`/${tenant.symbol}/${ctx.model}/landingpage/:meaId?/`}
        component={LandingPage}
      />
      <Route path={`${path}/:model/:id/:meaId?/`} component={SubViews} />
    </Switch>
  );
};

export default Routes;
